var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownLineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.959 14.0014L16.3257 8.6347L17.6673 10.0003L10.0007 17.667L2.33398 10.0003L3.67565 8.6347L9.04232 14.0014L9.04232 2.33366L10.959 2.33366L10.959 14.0014Z",
    fill: "#9EA4AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownLineArrow);
export default __webpack_public_path__ + "static/media/ic_down_line_arrow.8217a98c063dd098c1e66f77b9876631.svg";
export { ForwardRef as ReactComponent };